<template>
  <modal :ignoreBackdropClick="true" :show.sync="shown" headerClasses="justify-content-center" class="modal-options"
    :showClose="false" bodyClasses="center" v-if="
      itemsNotAvailable.length ||
      itemsWithDiffPrice.length ||
      itemsNotAvailableByType.length ||
      itemOptionsValuesAvailibility.length ||
      itemsNotAvailableForToday.length ||
      itemsNotAvailableByTime.length
    " modalClasses="modal-dialog-centered modal-dialog-scrollable">
    <h4 slot="header" class="title title-up">
      {{ startNewOrder ? $t("message.re_order_unavailable_title") : $t("message.confirm_re_ordering_title") }}
    </h4>
    <template>
      <i class="icon-style icon-color k-icon-menu"></i>

      <div v-if="itemsNotAvailable.length">

        <p class="info-message">
          {{ $t("message.confirm_re_ordering_message") }}
        </p>
        <p class="item-name" v-for="(item, index) in itemsNotAvailable" :key="index">
          {{ item.name }}
        </p>
      </div>

      <div v-if="itemsNotAvailableForToday.length">
        <p class="info-message">
          {{ $t("message.items_not_available_for_today") }}
        </p>
        <p class="item-name" v-for="(item, index) in itemsNotAvailableForToday" :key="index">
          {{ item.name }}
        </p>
      </div>

      <div v-if="itemsNotAvailableByTime.length">
        <p class="info-message">
          {{ $t("message.items_not_available_for_hour") }}
        </p>
        <p class="item-name" v-for="(item, index) in itemsNotAvailableByTime" :key="index">
          {{ item.name }}
        </p>
      </div>

      <div v-if="itemsNotAvailableByType.length">
        <p class="confirmation-message">
          {{ $t("message.items_not_available_for") }}
          <span>{{ getOrderTypeText(orderType) }}</span>
        </p>
        <p class="item-name" v-for="(item, index) in itemsNotAvailableByType" :key="index">
          {{ item.name }}
        </p>
      </div>

      <div v-if="itemOptionsValuesAvailibility.length">
        <p class="info-message">
          {{ $t("message.option_value_not_available") }}
        </p>
        <div v-for="(item, index) in itemOptionsValuesAvailibility" :key="index">
          <p class="item-name">
            {{ item.name }}
          </p>
          <div v-if="item.options.length">
            <ul class="options-list">
              <li v-for="(option, index) in item.options" :key="index">
                {{ option.name }}
                <ul v-if="option.missingValues && option.missingValues.length" class="options-list">
                  <li v-for="(optionValue, index) in option.missingValues" :key="index">
                    {{ optionValue.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

        </div>
        <p class="info-message">{{ $t("message.select_new_option") }}</p>
      </div>

      <div v-if="itemsWithDiffPrice.length">
        <p class="info-message">
          {{ $t("message.items_in_cart_price_changed") }}
        </p>
        <div class="grid-items" v-for="(item, index) in itemsWithDiffPrice" :key="index">
          <div class="grid-item-name">
            <p class="item-name">{{ item.name }}</p>
          </div>
          <div class="grid-item-price-status">
            <i class="icon-color" :class="getPriceIcon(item.increased)"></i>
          </div>
          <div class="grid-item-price">
            <p class="item-name">
              {{ item.menuItemPrice | currency }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <p class="confirmation-message">
          {{ startNewOrder ? $t("message.restart_order_msg") : $t("message.continue_re_ordering") }}
        </p>
      </div>
    </template>
    <template slot="footer">
      <n-button v-if="startNewOrder" type="warning" @click.native="redirectToHome">
        {{ $t("button.start_new_order") }}
      </n-button>
      <n-button v-else type="success" @click.native="confirmReOredering">
        {{ $t("button.re_order") }}
      </n-button>
      <n-button type="default" @click.native="closeModal">{{
        $t("button.cancel")
      }}</n-button>
    </template>
  </modal>
</template>
<script>
import { Button, Modal } from "@/components";
import {
  getOrderTypeText,
  getMenuItemPrice,
} from "@/utilities/helper";

export default {
  components: {
    [Button.name]: Button,
    Modal,
  },
  props: {
    itemsNotAvailable: Array,
    itemsWithDiffPrice: Array,
    itemsNotAvailableByType: Array,
    orderType: [String, Number],
    itemOptionsValuesAvailibility: Array,
    itemsNotAvailableForToday: Array,
    itemsNotAvailableByTime: Array,
    startNewOrder: Boolean
  },
  computed: {
    getPriceIcon() {
      return (increased) => {
        return increased ? "k-icon-priceup text-danger" : "k-icon-pricedown text-success";
      }
    },
  },
  data() {
    return {
      getOrderTypeText,
      getMenuItemPrice,
      shown: false,
    };
  },
  methods: {
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },
    confirmReOredering() {
      this.$root.$emit("CONTINUE_REORDER", true);
    },
    redirectToHome() {
      this.closeModal()
      this.$nextTick(() => {
        this.$router.push('/');
      })
    }
  },
};
</script>
<style scoped>
.icon-style {
  font-size: 5rem;
}

.text-style {
  font-size: 1.5rem;
  font-weight: 800;
}

p.info-message,
p.confirmation-message,
p.confirmation-message span {
  line-height: 1.6em;
  font-weight: bold;
  font-size: 1.1em;
}

p.info-message {
  font-weight: normal;
}

p.confirmation-message span,
.icon-color {
  color: #ff6600;
}

p.item-name {
  line-height: 1.1em;
  font-size: 1em;
  font-weight: 600;
}

.options-list {
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
}

.grid-items {
  display: grid;
  grid-template-columns: 70% 10% 20%;
}

.grid-item-name {
  grid-column: 1;
  text-align: start;
}

.grid-item-price-status {
  grid-column: 2;
}

.grid-item-price {
  grid-column: 3;
  text-align: end;
}
</style>
